export default __webpack_public_path__ + "static/media/fp-icon.8c706739.webp";